export enum AppearanceOptions {
    DARK = 'DARK',
    LIGHT = 'LIGHT',
}
